import React, { useCallback, useState, useEffect } from "react";
import { fromEvent } from "rxjs";
import "./ai-answer.scss";

export default function AIAnswer(): JSX.Element {
  const [load, setLoad] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [answerType, setAnswerType] = useState("");

  const sendMsgToIframe = useCallback(
    (data) => {
      const tmp = document.getElementById("answer") as HTMLIFrameElement;
      const win = tmp?.contentWindow;
      if (load && win) {
        win.postMessage(data, "*");
      }
    },
    [load]
  );

  const initIframe = useCallback(() => {
    const { protocol, host } = window.location;
    const path = "/market/ai-answer";
    let handleHost = host;
    handleHost = handleHost.replace("ebooking.", "eb.");
    const iframeUrl = `${protocol}//${handleHost}${path}`;
    const parent = document.getElementById("answer-iframe");
    const html: any = document.createElement("iframe") as HTMLIFrameElement;
    html.name = "answer";
    html.id = "answer";
    html.border = 0;
    html.style = "border:none;width:100%;height:100%";
    if (!document.getElementById("answer")) {
      parent.appendChild(html);
    }
    html.onload = () => {
      setLoad(true);
      window.addEventListener(
        "message",
        (event) => {
          if (event.origin !== `${protocol}//${handleHost}`) return;
          // 输出接收到的数据
          if (event?.data) {
            switch (event.data.type) {
              case "link":
                window.open(event.data.url, "_blank");
                break;
              default:
                break;
            }
          }
        },
        false
      );
    };
    html.src = iframeUrl;
  }, []);

  const openAnswer = useCallback(() => {
    setShowIframe(true);
    setAnswerType("small");
    setTimeout(() => {
      initIframe();
    });
  }, [initIframe]);

  // 放大
  const amplify = useCallback(() => {
    const postData = {
      type: "aiAnswer",
      data: {
        eventType: "amplify",
      },
    };
    sendMsgToIframe(postData);
    setAnswerType("common");
  }, [sendMsgToIframe]);

  // 缩小
  const scale = useCallback(() => {
    const postData = {
      type: "aiAnswer",
      data: {
        eventType: "scale",
      },
    };
    sendMsgToIframe(postData);
    setAnswerType("small");
  }, [sendMsgToIframe]);

  // 关闭
  const close = useCallback(() => {
    setShowIframe(false);
    setLoad(false);
  }, []);

  useEffect(() => {
    if (load) {
      const postData = {
        type: "aiAnswer",
        data: {
          platform: "eb",
          eventType: "onLoad",
          size: "common",
        },
      };
      sendMsgToIframe(postData);
    }
  }, [load, sendMsgToIframe]);

  useEffect(() => {
    const subscription = fromEvent<PopStateEvent>(window, "popstate").subscribe(
      () => {
        setShowIframe(false);
        setLoad(false);
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      <span
        className="ai-answer"
        role="button"
        aria-label="scale"
        tabIndex={0}
        onKeyDown={(e) => {
          console.log(e);
        }}
        onClick={openAnswer}
      >
        <span className="ai-img" />
        <span className="ai-text">Z-AI助理</span>
      </span>
      {showIframe && (
        <div className={`answer-container answer-container-${answerType}`}>
          <div className="answer-inner">
            <header>
              <span className="title">Z-AI助理</span>
              <div className="operate-btn">
                {answerType === "small" && (
                  <span
                    className="btn amplify"
                    role="button"
                    aria-label="amplify"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      console.log(e);
                    }}
                    onClick={amplify}
                  />
                )}
                {answerType === "common" && (
                  <span
                    className="btn scale"
                    role="button"
                    aria-label="scale"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      console.log(e);
                    }}
                    onClick={scale}
                  />
                )}
                <span
                  className="btn close"
                  role="button"
                  aria-label="close"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    console.log(e);
                  }}
                  onClick={close}
                />
              </div>
            </header>
            <div className="answer-iframe" id="answer-iframe"></div>
          </div>
        </div>
      )}
    </>
  );
}
